module.exports = __webpack_public_path__ + "static/logo-da6b9d43e2c8696408efa5522ffb5115.svg";